import {Injectable} from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';
import {Observable} from "rxjs/Rx";

@Injectable()
export class NeoChainService {

    constructor(
        private _rest: NeoRestService
    ) {
    }

    /**
     * Obtiene la lista de cadeas
     */
    getChains(): Observable<any> {
        return this._rest.get(`/chain`);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-chain/neo-chain.service.ts